module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.filterURL()),
      expression: "filterURL()",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.showCopySuccess),
      expression: "showCopySuccess",
      arg: "success"
    }],
    staticClass: "btn-close",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c03de55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/CopyButton.vue
// module id = 580
// module chunks = 0